import React from 'react'

import { Bold } from '@gousto-internal/citrus-react'

export const FormattedText = ({ text }: { text: string }) => (
  <>
    {text
      .split(/(\*\*[^*]+\*\*)/g)
      .map((part, index) =>
        part.startsWith('**') && part.endsWith('**') ? (
          <Bold key={index}>{part.slice(2, -2)}</Bold>
        ) : (
          part
        ),
      )}
  </>
)
